module.exports = __webpack_public_path__ + "static/img/newanli-14.a7943186.jpg";